import React from "react";
import BooksNavbar from "./BooksNavbar";
import BooksFooter from "./BooksFooter";

const BooksExtract = () => {
  return (
    <div>
      <section className="relative min-h-screen bg-white overflow-hidden">
        <BooksNavbar textColor="black" />

        <div className="relative z-10 pt-28 pb-16">
          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">
            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              READ AN EXTRACT
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Max
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              An extract from <em>Think Before You Think</em>
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>
          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="grid lg:grid-cols-2 gap-12 items-start">
              {/* Left Column */}
              <div className="max-w-2xl">
                <p
                  className="text-base text-black leading-relaxed mb-6 mt-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  I had never seen an NFL player in real life before, and somehow,
                  I hadn’t expected Max to be so big. I’m a bit over six feet, but
                  Max towered above me, and he seemed as wide across his shoulders
                  as he was tall.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Like most NFL players, Max had taken dozens of blows to his head
                  during a long and storied career that included more than a decade
                  in the league, countless games in packed stadiums, and many
                  moments of glory on national television.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  But although he’d been knocked unconscious countless times and
                  cracked his skull open more than once, that wasn’t why he had come
                  to see me. Since retiring, Max had developed a series of problems
                  that puzzled everyone around him.
                </p>
              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/max-remove-bg-io.png"
                  alt="Max"
                  className="w-full max-w-[650px]"
                />
              </div>
            </div>

            {/* Full Width Text */}
            <div className="mt-2">
              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                He had started gambling compulsively — so much so that he barely
                had anything left to show for his many professional achievements.
                He’d also started drinking heavily, hanging out in local bars until
                closing time and regaling anyone who would listen with stories of
                his sporting victories.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Unfortunately, when they wouldn’t listen, which was all too often,
                his response was to channel the aggression he had once focused on
                the football field into a barroom brawl. It was almost as if Max
                had lost his ability to predict, and prevent, the consequences of
                his actions.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Although he would often express regret, especially when he woke up
                in a police cell the next day, in the heat of the moment Max did
                exactly what he felt like doing. He threw caution to the wind,
                along with his reputation, his marriage, and his bank account.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                We invited Max into our MRI scanner and asked him to perform a
                deceptively simple task. Words appeared on a screen in different
                colours. Sometimes the word <em>RED</em> was written in red.
                Sometimes it was written in blue. His job was simple: ignore the
                word itself and identify the colour in which it was written.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                When the word <em>RED</em> appeared in blue ink, Max repeatedly
                chose the wrong answer. He knew the rules. He understood the task.
                He simply couldn’t stop himself responding to the obvious but
                incorrect choice.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                On my computer screen in the control room, Max’s brain was fully
                visible, beautifully rendered in three dimensions. But as tiny red
                and green blobs started to appear on the screen, indicating which
                parts of Max’s brain were active or inactive, it was clear that
                something wasn’t quite right.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                One part of his frontal lobes, which are vast regions that account
                for more than 30 percent of the brain’s entire volume, was
                extremely active — more active than normal, in fact. After decades
                of repetitive injury, a communication breakdown had occurred
                between Max’s frontal lobes and the rest of his brain, leaving
                them struggling to function effectively.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Without the rest of the brain for backup, the frontal lobes needed
                to work harder to perform even the simplest daily tasks.
                Importantly, Max still knew right from wrong. He could still tell
                you how long a football field is. He could even accurately report
                the final score of most of the professional games he’d played
                during his long career.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In most ways, Max’s intelligence was unchanged. Yet somehow, he
                was now unable to use his intelligence to direct his behaviour. He
                couldn’t exercise any inhibitory control — the brain function that
                prevents us from just doing, or saying, the first thing that pops
                into our heads without giving it proper consideration.
              </p>

              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Nor was Max able to effectively solve problems, coherently plan
                for his future, make sound decisions, prioritize what was important
                in his life, and deduce what other people were thinking. Life for
                him had become a storm of random mysterious incidents that he
                participated in but over which he had little control. In other
                words, what Max was experiencing was a complete and utter failure
                of his executive functions.
              </p>
            </div>
          </div>
        </div>
      </section>

      <BooksFooter />
    </div>
  );
};

export default BooksExtract;





// import React from "react";
// import BooksNavbar from "./BooksNavbar";
// import BooksFooter from "./BooksFooter";

// const BooksExtract = () => {
//   return (
//     <div>
//       {/* HERO */}
//       <section className="relative min-h-[90vh] bg-white overflow-hidden">
//         <BooksNavbar textColor="black" />

//         <div className="relative z-10 min-h-[90vh] flex items-center pt-28 pb-16">
//           <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 items-center">
//             {/* left text */}
//             <div className="text-center lg:text-left">
//               <p
//                 className="text-xs tracking-[0.35em] text-[#8c8b5f] mb-4 uppercase"
//                 style={{ fontFamily: "Playfair Display, serif" }}
//               >
//                 Read an Extract
//               </p>

//               <h1
//                 className="text-5xl md:text-7xl text-black leading-tight mb-6"
//                 style={{ fontFamily: "Playfair Display, serif" }}
//               >
//                 Max
//               </h1>

//               <div className="flex items-center w-full max-w-sm mb-8 mx-auto lg:mx-0">
//                 <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
//                 <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
//                 <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
//               </div>

//               <p
//                 className="text-xl md:text-2xl italic text-[#5f6f4f] leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0"
//                 style={{ fontFamily: "Playfair Display, serif" }}
//               >
//                 An extract from <em>Think Before You Think</em>, exploring what
//                 happens when intelligence remains intact, but executive function
//                 begins to fail.
//               </p>

//               <a
//                 href="#extract"
//                 className="inline-block bg-[#D4AF37] text-black px-6 py-3 text-sm font-semibold tracking-widest"
//                 style={{ fontFamily: "Playfair Display, serif" }}
//               >
//                 READ THE EXTRACT
//               </a>
//             </div>

//             {/* right image */}
//             <div className="flex justify-center lg:justify-end">
//               <img
//                 src="/emotional_regulation.png"
//                 alt="A man steering a ship through a storm"
//                 className="w-full max-w-[700px]"
//               />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* INTRO STRIP */}
//       {/* <section className="bg-[#f5f3ef] py-14">
//         <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
//           <p
//             className="text-xs tracking-[0.35em] text-[#D4AF37] mb-4 uppercase"
//             style={{ fontFamily: "Playfair Display, serif" }}
//           >
//             From the Book
//           </p>

//           <h2
//             className="text-3xl md:text-5xl text-black leading-tight mb-6"
//             style={{ fontFamily: "Playfair Display, serif" }}
//           >
//             What happens when the brain can no longer stop itself?
//           </h2>

//           <p
//             className="text-gray-700 leading-relaxed max-w-3xl mx-auto"
//             style={{ fontFamily: "Playfair Display, serif" }}
//           >
//             This extract introduces Max, a former NFL player whose intelligence
//             remained largely unchanged, even as his ability to control his
//             behaviour began to collapse.
//           </p>
//         </div>
//       </section> */}

//       {/* EXTRACT */}
//       <section id="extract" className="bg-white py-16">
//         <div className="max-w-4xl mx-auto px-6 md:px-12">
//           <div className="text-center mb-12">
//             <p
//               className="text-xs tracking-[0.35em] text-[#8c8b5f] mb-4 uppercase"
//               style={{ fontFamily: "Playfair Display, serif" }}
//             >
//               Extract
//             </p>

//             <h2
//               className="text-4xl md:text-6xl text-black leading-tight"
//               style={{ fontFamily: "Playfair Display, serif" }}
//             >
//               Max
//             </h2>

//             <div className="flex items-center w-full max-w-sm mt-8 mx-auto">
//               <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
//               <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
//               <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
//             </div>
//           </div>

//           <div
//             className="text-lg text-gray-800 leading-loose"
//             style={{ fontFamily: "Playfair Display, serif" }}
//           >
//             <p className="mb-6">
//               I had never seen an NFL player in real life before, and somehow,
//               I hadn’t expected Max to be so big. I’m a bit over six feet, but
//               Max towered above me, and he seemed as wide across his shoulders
//               as he was tall.
//             </p>

//             <p className="mb-6">
//               Like most NFL players, Max had taken dozens of blows to his head
//               during a long and storied career that included more than a decade
//               in the league, countless games in packed stadiums, and many
//               moments of glory on national television.
//             </p>

//             <p className="mb-6">
//               But although he’d been knocked unconscious countless times and
//               cracked his skull open more than once, that wasn’t why he had come
//               to see me. Since retiring, Max had developed a series of problems
//               that puzzled everyone around him.
//             </p>

//             <p className="mb-6">
//               He had started gambling compulsively — so much so that he barely
//               had anything left to show for his many professional achievements.
//               He’d also started drinking heavily, hanging out in local bars until
//               closing time and regaling anyone who would listen with stories of
//               his sporting victories.
//             </p>

//             <p className="mb-6">
//               Unfortunately, when they wouldn’t listen, which was all too often,
//               his response was to channel the aggression he had once focused on
//               the football field into a barroom brawl. It was almost as if Max
//               had lost his ability to predict, and prevent, the consequences of
//               his actions.
//             </p>

//             <p className="mb-6">
//               Although he would often express regret, especially when he woke up
//               in a police cell the next day, in the heat of the moment Max did
//               exactly what he felt like doing. He threw caution to the wind,
//               along with his reputation, his marriage, and his bank account.
//             </p>

//             <p className="mb-6">
//               We invited Max into our MRI scanner and asked him to perform a
//               deceptively simple task. Words appeared on a screen in different
//               colours. Sometimes the word <em>RED</em> was written in red.
//               Sometimes it was written in blue. His job was simple: ignore the
//               word itself and identify the colour in which it was written.
//             </p>

//             <p className="mb-6">
//               When the word <em>RED</em> appeared in blue ink, Max repeatedly
//               chose the wrong answer. He knew the rules. He understood the task.
//               He simply couldn’t stop himself responding to the obvious but
//               incorrect choice.
//             </p>

//             <p className="mb-6">
//               On my computer screen in the control room, Max’s brain was fully
//               visible, beautifully rendered in three dimensions. But as tiny red
//               and green blobs started to appear on the screen, indicating which
//               parts of Max’s brain were active or inactive, it was clear that
//               something wasn’t quite right.
//             </p>

//             <p className="mb-6">
//               One part of his frontal lobes, which are vast regions that account
//               for more than 30 percent of the brain’s entire volume, was
//               extremely active — more active than normal, in fact. After decades
//               of repetitive injury, a communication breakdown had occurred
//               between Max’s frontal lobes and the rest of his brain, leaving
//               them struggling to function effectively.
//             </p>

//             <p className="mb-6">
//               Without the rest of the brain for backup, the frontal lobes needed
//               to work harder to perform even the simplest daily tasks.
//               Importantly, Max still knew right from wrong. He could still tell
//               you how long a football field is. He could even accurately report
//               the final score of most of the professional games he’d played
//               during his long career.
//             </p>

//             <p className="mb-6">
//               In most ways, Max’s intelligence was unchanged. Yet somehow, he
//               was now unable to use his intelligence to direct his behaviour. He
//               couldn’t exercise any inhibitory control — the brain function that
//               prevents us from just doing, or saying, the first thing that pops
//               into our heads without giving it proper consideration.
//             </p>

//             <p>
//               Nor was Max able to effectively solve problems, coherently plan
//               for his future, make sound decisions, prioritize what was important
//               in his life, and deduce what other people were thinking. Life for
//               him had become a storm of random mysterious incidents that he
//               participated in but over which he had little control. In other
//               words, what Max was experiencing was a complete and utter failure
//               of his executive functions.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="bg-[#f5f3ef] py-14">
//         <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-8">
//           <div className="text-center md:text-left">
//             <h2
//               className="text-3xl md:text-4xl text-black mb-3"
//               style={{ fontFamily: "Playfair Display, serif" }}
//             >
//               Think before you think.
//             </h2>

//             <p
//               className="text-gray-600"
//               style={{ fontFamily: "Playfair Display, serif" }}
//             >
//               Understand your executive function. Change your life.
//             </p>
//           </div>

//           <div className="flex flex-col sm:flex-row gap-4">
//             <a
//               href="/books/science"
//               className="border border-black text-black px-6 py-3 text-sm font-semibold tracking-widest text-center"
//               style={{ fontFamily: "Playfair Display, serif" }}
//             >
//               EXPLORE THE SCIENCE
//             </a>

//             <a
//               href="https://wwnorton.com/books/9781324075165"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="bg-[#D4AF37] text-black px-6 py-3 text-sm font-semibold tracking-widest text-center"
//               style={{ fontFamily: "Playfair Display, serif" }}
//             >
//               PREORDER
//             </a>
//           </div>
//         </div>
//       </section>

//       <BooksFooter />
//     </div>
//   );
// };

// export default BooksExtract;